import { configureStore, combineReducers, createListenerMiddleware } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import authReducer, { logout } from '../features/auth/authSlice';
import userParamsReducer from './slices/userParamsSlice';
import customerSelectionReducer from './slices/customerSelectionSlice';
import techSupportChatReducer from './slices/techSupportChatSlice';

import { rootApi } from '../api/rootApi';
// Tüm endpoint dosyalarının modül olarak yüklenip rootApi'ye inject edilmesini
// tetiklemek için barrel'ı yan etki (side-effect) olarak içe aktarıyoruz.
import '../api';

// Combine all reducers
const appReducer = combineReducers({
  auth: authReducer,
  userParams: userParamsReducer,
  customerSelection: customerSelectionReducer,
  techSupportChat: techSupportChatReducer,
  // Tüm RTK Query endpoint'leri tek merkezi rootApi üzerine inject edilir
  [rootApi.reducerPath]: rootApi.reducer
});

// Root reducer that handles global state reset on logout
const rootReducer = (state, action) => {
  // When logout action is dispatched, reset the entire state
  if (action.type === 'auth/logout') {
    // Reset all state except keep initial states
    state = undefined;
  }
  
  return appReducer(state, action);
};

// Logout hangi yerden tetiklenirse tetiklensin RTK Query cache'i ve abonelikleri sıfırlanır
const listenerMiddleware = createListenerMiddleware();
listenerMiddleware.startListening({
  actionCreator: logout,
  effect: (_, listenerApi) => {
    listenerApi.dispatch(rootApi.util.resetApiState());
  }
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(listenerMiddleware.middleware).concat(rootApi.middleware),
});

setupListeners(store.dispatch);
